import { render, staticRenderFns } from "./createSettlement.vue?vue&type=template&id=2307dbe8&scoped=true&"
import script from "./createSettlement.vue?vue&type=script&lang=js&"
export * from "./createSettlement.vue?vue&type=script&lang=js&"
import style0 from "./createSettlement.vue?vue&type=style&index=0&id=2307dbe8&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2307dbe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2307dbe8')) {
      api.createRecord('2307dbe8', component.options)
    } else {
      api.reload('2307dbe8', component.options)
    }
    module.hot.accept("./createSettlement.vue?vue&type=template&id=2307dbe8&scoped=true&", function () {
      api.rerender('2307dbe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/receiveSettlement/createSettlement.vue"
export default component.exports